
export function decodeToken(token: string) {
  const segmentos = token.split('.')
  // ed25519 sobre compacto: 2 segmentos (payload.firma)
  // JWT legacy: 3 segmentos (header.payload.signature)
  const indicePayload = segmentos.length === 2 ? 0 : 1
  const base64Url = segmentos[indicePayload]
  if (!base64Url) throw new Error('Token malformado')
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => {
        return `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`
      })
      .join('')
  )
  return JSON.parse(jsonPayload)
}

